import { c as _c } from "react/compiler-runtime";
interface BottomNavSearchIconProps {
  className?: string;
}
const BottomNavSearchIcon = t0 => {
  const $ = _c(3);
  const {
    className
  } = t0;
  const t1 = `${className}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M20.4858 14.5837C20.4858 13.6444 20.3009 12.7135 19.9414 11.8457C19.5819 10.9781 19.0552 10.1892 18.3911 9.52515C17.727 8.86109 16.9382 8.33426 16.0706 7.97485C15.2029 7.61548 14.2729 7.43046 13.3337 7.43042C12.3944 7.43042 11.4635 7.61539 10.5957 7.97485C9.728 8.33432 8.93927 8.86102 8.27515 9.52515C6.93372 10.8666 6.18042 12.6867 6.18042 14.5837C6.1805 16.4806 6.93398 18.2998 8.27515 19.6411C9.61658 20.9825 11.4367 21.7358 13.3337 21.7358C15.2307 21.7358 17.0497 20.9825 18.3911 19.6411C19.0553 18.9769 19.5819 18.1884 19.9414 17.3206C20.3008 16.4528 20.4858 15.523 20.4858 14.5837ZM22.8479 14.5837C22.8479 15.833 22.6008 17.0697 22.1228 18.2239C21.7961 19.0126 21.3629 19.75 20.8411 20.4211L24.585 24.165C25.046 24.6261 25.046 25.3739 24.585 25.835C24.1239 26.296 23.3761 26.296 22.915 25.835L19.1711 22.0911C17.5103 23.3826 15.4599 24.0978 13.3337 24.0979C10.8106 24.0979 8.39064 23.0951 6.60645 21.311C4.82229 19.5269 3.81966 17.1069 3.81958 14.5837C3.81958 12.0605 4.82223 9.64067 6.60645 7.85645C7.48987 6.97302 8.53814 6.27158 9.69238 5.79346C10.8467 5.31533 12.0843 5.06958 13.3337 5.06958C14.5829 5.06962 15.8198 5.31549 16.9739 5.79346C18.1282 6.27158 19.1776 6.97299 20.061 7.85645C20.9443 8.73975 21.6447 9.78835 22.1228 10.9424C22.6009 12.0967 22.8479 13.3343 22.8479 14.5837Z" fill="current" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <svg className={t1} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" fill="currentColor" width="30" height="30">{t2}</svg>;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  return t3;
};
export default BottomNavSearchIcon;